import { render, staticRenderFns } from "./NeedAcceptUserTerms.vue?vue&type=template&id=2cba6b24&"
import script from "./NeedAcceptUserTerms.vue?vue&type=script&lang=js&"
export * from "./NeedAcceptUserTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports